<app-page-content>
  <app-doenkids-menu-bar menuBar [showBackButton]="true">
    <div right>
      @if ((isAdmin$ | async)) {
        <button
          mat-icon-button
          type="button"
          (click)="goToActivities()"
          [matTooltip]="'user_details.activity.show.tooltip' | translate"
          >
          <mat-icon>assignment</mat-icon>
        </button>
      }
    </div>
  </app-doenkids-menu-bar>
  <div content class="form-container">
    <form [formGroup]="form">
      <div class="user-details flex-row gap-6 md-flex-col">
        <div class="flex-col flex-1">
          <app-asset-upload purpose="avatar" identifier="avatar" (uploaded)="addFeaturedImage($event)" [disabled]="!(canEditUsers$ | async)">
            <ng-template let-uploadData="uploadData">
              <div class="flex-1 flex-col gap-6 md-flex-row sm-flex-col justify-between items-center">
                <div class="avatar-wrapper">
                  <app-doenkids-image [maxWidth]="200" [maxHeight]="400" [preview]="true"
                    [mediaItem]="( mediaItem$ | async )" [defaultPlaceHolder]="avatarPlaceholder">
                  </app-doenkids-image>
                </div>
                <app-select-media [uploadData]="uploadData" identifier="avatar" purpose="avatar" (selected)="updateFeaturedImage($event)" [disabled]="!(canEditUsers$ | async)">
                </app-select-media>
              </div>
            </ng-template>
          </app-asset-upload>
        </div>
        <div class="user-details-fields">
          @if (canEditUsers$ | async) {
            <div>
              <div class="organization-selector flex-row justify-center items-center">
                <mat-form-field appearance="outline">
                  <mat-label>{{ 'user.organization.label' | translate }}</mat-label>
                  <input matInput [value]="(user$ | async)?.organization_unit" readonly>
                </mat-form-field>
                <button mat-icon-button (click)="changeOrganization()" [matTooltip]="'user.organization.select.tooltip' | translate">
                  <mat-icon>edit</mat-icon>
                </button>
              </div>
            </div>
          }
          <app-user-form formControlName="user" [disabled]="!(canEditUsers$ | async)">
            @if ((isAdmin$ | async)) {
              <button
                color="secondary"
                mat-button
                type="button"
                (click)="syncAuth0Email()"
                [disabled]="!(auth0StatusIsEmailMismatch$ | async)"
                >
                {{ 'user_details.sync_email.label' | translate }}
              </button>
            }
            @if (!(isReader$ | async)) {
              <button
                color="secondary"
                mat-button
                type="button"
                (click)="linkWithOrganization()"
                [disabled]="!(canEditUsers$ | async)"
                >
                {{ 'generic.link' | translate | uppercase }}
              </button>
            }
            @if (!(isReader$ | async)) {
              <button
                color="primary"
                mat-button
                type="button"
                (click)="saveDetails()"
                [disabled]="!form.dirty || !form.valid || !(canEditUsers$ | async)"
                >
                {{ 'generic.save' | translate | uppercase }}
              </button>
            }
          </app-user-form>
        </div>
      </div>
    </form>

    <app-sortable-list class="not-selectable" [fields]="(fields$ | async)" [list$]="(user$ | async)?.linked_organization_units || []">
      <ng-container *appSortableListFields="let list">
        @for (location of list; track location) {
          <tr>
            <td>
              <div class="cell-wrapper">{{location.name}}</div>
            </td>
            <td>
              <div class="cell-wrapper">{{location.activity_type }}</div>
            </td>
            <td>
              <div class="cell-wrapper">{{ getOrganizationNodePath(location.node_path_name) }}</div>
            </td>
            <td class="action-col">
              @if (!(isReader$ | async)) {
                <button mat-icon-button (click)="removeLocation( location.id )" [disabled]="!(canEditUsers$ | async)">
                  <mat-icon>delete</mat-icon>
                </button>
              }
            </td>
          </tr>
        }
        @if (list?.length === 0) {
          <tr>
            <td [attr.colspan]="(fields$ | async).length">
              <div class="cell-wrapper">{{ 'user_details.no_results' | translate }}</div>
            </td>
          </tr>
        }
      </ng-container>
    </app-sortable-list>
  </div>
</app-page-content>
